import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Translate from 'translate';
import IconProgress from 'material-ui/CircularProgress';
import ConfigurationService from 'services/ConfigurationService'
import { toggleLoading, updateApiStatus } from 'stores/actions/';
import APPCONFIG from 'constants/Config';
import moment from 'moment';

class AppInfoModalEvents extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {},
    };
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.getData()
    }
  }

  getData() {
    //this.props.toggleLoading( true );

    ConfigurationService.getAppConfiguration().then( ( response ) => {
      //this.props.toggleLoading( false );

      if( response.data ) {
        this.setState( { data: response.data } );
        this.props.updateApiStatus( {
          incmsApiStatus: response.data.incmsApiStatus
        } )
      }
    } );
  }

  divLoading = () => {

      return (
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      )

  }
  closeModal = () => {
    this.setState( { data: {} } );
    this.props.onClose()
  };

  render() {
    const { open } = this.props;
    const { data } = this.state;


    return (
      <Modal closeOnEsc={false}
             modalClassName="col-md-5"
             open={open}
             onClose={this.closeModal}>
        <h5 className="mt-0">Recent Events</h5>
        
        <div className="row">
        <div class="list-group">
            <a href="#" class="list-group-item list-group-item-action">
                <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1 bg-success" ><span style={{color:'white',padding:'2px 4px'}}>RUNNING</span></h5>
                <small>{moment( new Date()).format( 'DD/MM/YY hh:MM A' )}</small>
                </div>
                <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>
                <small>Donec id elit non mi porta.</small>
            </a>
            <a href="#" class="list-group-item list-group-item-action">
                <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1 bg-danger"><span style={{color:'white',padding:'2px 4px'}}>DOWN </span></h5>
                <small class="text-muted">{moment( new Date()).format( 'DD/MM/YY hh:MM A' )}</small>
                </div>
                <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>
                <small class="text-muted">Donec id elit non mi porta.</small>
            </a>
            </div>
        </div>
        <div className="row" style={{display:'none'}}>
          <div className="box box-default" style={{width:'100%'}}>
            <div className="box-body">
              <table class="table table-borderless">
                <thead>
                  <tr style={{display: 'none'}}>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row" className='color-primary' style={{width:'25%'}}>API Status</th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      
                    </td>
                    <td>
                      <span style={{background:'#66BB6A',padding:'2px 4px',color:'white'}}><strong>RUNNING</strong></span>
                      {/* <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span> */}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" className='color-primary' style={{width:'25%'}}>Database</th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      
                    </td>
                    <td>
                      <span style={{background:'#66BB6A',padding:'2px 4px',color:'white'}}><strong>RUNNING</strong></span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" className='color-primary' style={{width:'25%'}}>Network</th>
                    <td style={{width:'50%',textAlign:'center'}}>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-success ml-1"/></span>
                      <span><i className="fa fa-2x fa-circle color-danger ml-1"/></span>
                      
                    </td>
                    <td>
                      <span style={{background:'#dc3545',padding:'2px 4px',color:'white'}}><strong>DOWN</strong></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="text-right">
          <button className="btn btn-info" onClick={this.closeModal}><Translate id="close"/></button>
        </div>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  updateApiStatus: ( data ) => {
    dispatch( updateApiStatus( data ) );
  }
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( AppInfoModalEvents );




// WEBPACK FOOTER //
// ./routes/app/components/Navigation/AppInfoModalEvents/index.js